/**
 * pure-forms
 * Pure functional form state management
 * Written by Jonathan Ziller.
 * MIT license.
 * https://github.com/MrWolfZ/pure-forms
 */
export * from './src/pure-forms';
